module.exports = __webpack_public_path__ + "img/Futian_logo.74b93f44.png";